/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Pairing_Public_EmailInputs */

const cs_ebr_pairing_public_email = /** @type {(inputs: Ebr_Pairing_Public_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dle veřejného e-mailu (měkké)`)
};

const en_ebr_pairing_public_email = /** @type {(inputs: Ebr_Pairing_Public_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`by public e-mail (soft)`)
};

/**
* | output |
* | --- |
* | "by public e-mail (soft)" |
*
* @param {Ebr_Pairing_Public_EmailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_pairing_public_email = /** @type {((inputs?: Ebr_Pairing_Public_EmailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Pairing_Public_EmailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_pairing_public_email(inputs)
	return cs_ebr_pairing_public_email(inputs)
});